import React, { forwardRef, Ref } from "react";
import { Autocomplete, AutocompleteProps } from "@heroui/react";

function AppAutocompleteInner<T extends object>(
  props: AutocompleteProps<T>,
  ref: Ref<HTMLInputElement>
) {
  const baseClass = "rounded-xl data-[focus-visible=true]:outline-0 data-[focus-visible=true]:ring-0 data-[focus-visible=true]:ring-offset-0 data-[hover=true]:bg-[#EBEBEC] data-[focus=true]:bg-[#EBEBEC] data-[selected=true]:bg-[#EBEBEC]";
  const incomingBase = props.listboxProps?.itemClasses?.base;
  const mergedBase = incomingBase ? baseClass + " " + incomingBase : baseClass;

  return (
    <Autocomplete
      {...props}
      ref={ref}
      listboxProps={{
        ...props.listboxProps,
        itemClasses: {
          ...props.listboxProps?.itemClasses,
          base: mergedBase,
        },
      }}
    />
  );
}

const AppAutocomplete = forwardRef(AppAutocompleteInner) as <T extends object>(
  props: AutocompleteProps<T> & { ref?: Ref<HTMLInputElement> }
) => React.ReactElement;

export default AppAutocomplete;

